import { Link } from 'foundations-components/transitional/components/Link';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Image } from 'foundations-components/transitional/components/Image';
// @ts-expect-error bender imports are untyped
import defaultAvatar from 'bender-url!../../../../images/default-avatar.png';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FaceNavHeader = ({
  name,
  avatarUrl,
  userEmail,
  userPreferencesUrl
}) => {
  return /*#__PURE__*/_jsx(View, {
    borderBlockEndStyle: "solid",
    borderBlockEndWidth: "100",
    borderColor: "border-core-default",
    padding: "400",
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "start",
      gap: "300",
      children: [/*#__PURE__*/_jsx(Image, {
        alt: I18n.text('learningCenter.faceNav.avatar'),
        blockSize: "48px",
        responsive: true,
        shape: "circle",
        src: avatarUrl || defaultAvatar
      }), /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        gap: "100",
        maxInlineSize: "100%",
        minInlineSize: "0",
        children: [/*#__PURE__*/_jsx(Text, {
          as: "strong",
          children: name
        }), /*#__PURE__*/_jsx(Text, {
          as: "small",
          color: "text-core-subtle",
          truncate: true,
          children: userEmail
        }), /*#__PURE__*/_jsx(Link, {
          href: userPreferencesUrl,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.faceNav.profileAndPreferences"
          })
        })]
      })]
    })
  });
};